mutation PreviewApprovalTesting(
  $input: PreviewApprovalTestingInput!
  $id: UUID!
) {
  previewApprovalTesting(input: $input) {
    approvalMapTypes {
      _accountingStampDate
      _accountingStampTransactionReference
      _accountingStampUserId
      _accountingStampUserName
      _isAccountingEntryStampedComplete
      _isTransactionCancelled
      appId
      approvalType
      digitalSignature
      displayEntityApprovalId
      entityApprovalId
      entityId
      entityTypeId
      errorMessage
      id
      isAddedApprover
      isApproval
      isApproved
      isBranch
      isErrorFound
      isPending
      isRevoked
      isTree
      level
      messageDisplayApprovalEntityId
      name
      requestedDate
      sequence
      sortOrder
      statusDate
      topic
      subTopic
      status
      parentId
      messageUserId
      isRejected
    }
    query {
      approval(id: $id) {
        _infoLines {
          isTested
          activeTestCount
        }
      }
    }
  }
}
